import { render, staticRenderFns } from "./paystatistical.vue?vue&type=template&id=3904935b&scoped=true&"
import script from "./paystatistical.vue?vue&type=script&lang=js&"
export * from "./paystatistical.vue?vue&type=script&lang=js&"
import style0 from "./paystatistical.vue?vue&type=style&index=0&id=3904935b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904935b",
  null
  
)

export default component.exports